import React, { useState } from 'react';
import {
    TextInput,
    SelectInput,
    Create,
    TabbedForm,
    FormTab,
    required,
    Toolbar,
    SaveButton,
    BooleanInput,
    useNotify,
    useRedirect,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Iframe from '../controls/Iframe';
import jwt_decode from 'jwt-decode';
import { Grid, Box, Typography, Container, Paper, Button, Alert, Snackbar } from '@mui/material';
import { CheckCircle, Info, LocalHospital, DoneAll } from '@mui/icons-material';


const { REACT_APP_EDUCATION_URL } = process.env ;
const { REACT_APP_RISK_URL } = process.env ;
const { REACT_APP_MEDICATIONS_URL } = process.env ;



let ssn = null
//let branch_code =  (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).branch_code : ''): '';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};


const formSectionStyle = {
    p: 3,
    mb: 2,
    backgroundColor: '#f9f9f9',
    borderRadius: 2,
    width: '100%',
    mr: 3,
};

const iframeContainerStyle = {
    width: '100%', // ✅ Ensures full width inside Paper
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px',
    padding: '10px 0'
};

const iframeStyle = {
    width: '100%', // ✅ Full width
    height: '150px', // ✅ Ensures proper height for readability
    border: 'none',
    display: 'block'
};

const sectionStyle = {
    mb: 4,
    p: 4,
    bgcolor: '#f1f8ff',
    borderRadius: 2,
    boxShadow: 3
};
const editStyles = {
    root: { alignItems: 'flex-start'},
    initial: {  width: '5em' },
    booth: {  width: '2em' },
    time: {  width: '7em' },
    volume: {  width: '3em' },
    comments: {  width: '30em' },
   
};

const leftRight = [
    {
        id: 'L',
        name: 'Left'
    },
    {
        id : 'R',
        name: 'Right'
    }
  ]

const OneTwo = [
    {
        id: '1',
        name: '1'
    },
    {
        id : '2',
        name: '2'
    }
  ]

  const YesNoExt = [
    {
        id: 'Y',
        name: 'Yes'
    },
    {
        id : 'N',
        name: 'No'
    },
    {
        id : '/',
        name: 'N/A'
    }
  ]

  const YesNo = [
    {
        id: 'Y',
        name: 'Yes'
    },
    {
        id : 'N',
        name: 'No'
    }
  ]

  const YesNoFull = [
    {
        id: 'Yes',
        name: 'Yes'
    },
    {
        id : 'No',
        name: 'No'
    }
  ]

  const deferralCodes = [

    {
        id: 'PR',
        name: 'Permanently rejected'
    },
    {
        id : 'TD',
        name: 'Temporarly Deferred'
    },
    {
        id: 'N/A',
        name: 'Not applicable'
    }
  ]
/*
const ProcessingToolbar = props => (
    
    <Toolbar {...props} >
        <SaveButton
            label="save"
           // redirect={'/custom'}
            submitOnEnter={true}
            id="save"
            style={{display: 'none'}}
        />
    </Toolbar>
);
*/
const CreateToolbar = (props) => (
    <Toolbar {...props} sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <Grid container justifyContent="center">
            <Grid item>
                <SaveButton
                    {...props}
                    id="save"
                    label="✅ Submit & Complete"
                    //redirect="/"
                    submitOnEnter
                    sx={{
                        fontSize: 22,       // Large text
                        px: 6,              // Padding X
                        py: 2,              // Padding Y
                        borderRadius: 3,    // Rounded edges
                        bgcolor: 'primary.main',  // Primary button color
                        color: 'white',     // White text
                        boxShadow: 4,       // Adds depth
                        width: 'auto',      // Auto width based on content
                        minWidth: '280px',  // Minimum width
                        height: '50px',     // Button height
                        whiteSpace: 'nowrap', // Prevents wrapping
                        textAlign: 'center', // Centers text
                        display: 'inline-flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mb: 4, // Bottom margin
                        textTransform: 'none', // Prevents automatic uppercase
                        transition: 'all 0.3s ease-in-out', // Smooth hover effect
                        '&:hover': { 
                            bgcolor: 'primary.dark', // Darker shade on hover
                            transform: 'scale(1.05)', // Slight zoom effect
                            boxShadow: '0px 6px 12px rgba(0,0,0,0.3)', // Stronger shadow on hover
                        }
                    }}
                    style={{display: 'none'}}
                />
            </Grid>
        </Grid>
    </Toolbar>
);


function hasRead(val){

    if(val){
        
        document.getElementById("history").removeAttribute("style");
      
        document.getElementById("save").removeAttribute("style");
        document.getElementById("ack").removeAttribute("style");
        document.getElementById("history").focus();
        document.getElementById("history").click();
    }else{
      
        document.getElementById("history").setAttribute("style", "display: none;");
      
        document.getElementById("save").setAttribute("style", "display: none;");
        document.getElementById("ack").setAttribute("style", "color: red;");
    }
}





const QuestionCreate =({ classes, ...props }) => {

    const [message, setMessage] = useState(null);
    const [notifyMessage, setNotifyMessage] = useState(null);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const notify = useNotify();
    const redirect = useRedirect();

    const handleSuccess = () => {
        setNotifyMessage({ type: "success", text: "✅ Submission successful! Please proceed to the front desk." });
        setOpenSnackbar(true);
        setTimeout(() => redirect('/custom'), 3000); // Redirect after showing the message
    };
    
    const handleFailure = () => {
        setNotifyMessage({ type: "error", text: "❌ Submission failed. Please contact the front desk." });
        setOpenSnackbar(true);
    };

    return (
        <Create 
            title='Donor Questionnaire Worksheet' 
            {...props}  
            onSuccess={handleSuccess} 
            onFailure={handleFailure}
            >
            
            <TabbedForm toolbar={<CreateToolbar/>}>      
                <FormTab label="Must Read" icon={<Info />} >
                    
                
                <Box sx={iframeContainerStyle}> 
                                
                    <Typography variant="h5" sx={{ mb: 2, display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                        <LocalHospital sx={{ fontSize: 30, mr: 1, color: '#1976d2' }}/> Education
                    </Typography>
                    
                    <Box width="100%">
                        <Iframe source={REACT_APP_EDUCATION_URL} style={iframeStyle} />
                    </Box>

                    <Typography variant="h5"  sx={{ mb: 2, display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                        <LocalHospital sx={{ fontSize: 30, mr: 1, color: 'purple' }} /> Risks
                    </Typography>
                    <Box width="100%">
                        <Iframe source={REACT_APP_RISK_URL} style={iframeStyle} />
                    </Box>

                    <Typography variant="h5"  sx={{ mb: 2, display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                        <LocalHospital  sx={{ fontSize: 30, mr: 1, color: 'red' }} /> Medications
                    </Typography>
                    <Box width="100%">
                        <Iframe source={REACT_APP_MEDICATIONS_URL} style={iframeStyle} />
                    </Box>
                </Box>
                <Box textAlign="center" mt={4} style={{ width: '100%'}}>
                    <BooleanInput 
                        id="ack" 
                        style={{color:'red'}} 
                        label="I acknowledge that donor has read and understood all above 3 documents (Education, Risks and Medications)" 
                        source="DUMMY" 
                        onChange={(value) => hasRead(value)} 
                        sx={{ fontSize: '1.5rem' }}
                    />
                </Box> 
                
                </FormTab> 
                <FormTab label="History Questionnaire" id="history"  style={{display: 'none'}} icon={<CheckCircle />}>  
                    <Container maxWidth="md" >
                        <Paper elevation={6} sx={{ p: 3, borderRadius: 4 ,  width: '95%'}}>   
                        {/* Section 1: General Health Questions */}
                        <Box sx={sectionStyle}>
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    Since you last donated plasma:
                                </Typography>
                                <Grid container spacing={2}  >
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Are you feeling healthy and well today?</span>
                                        <SelectInput source="healthy" label="" choices={YesNo} validate={required()} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Have you gotten a tattoo or had one touched up?</span>
                                        <SelectInput source="tattoo" label="" choices={YesNo} validate={required()} fullWidth />
                                    </Grid>
                                </Grid>
                            </Box>

                            {/* Section 2: Medical Procedures */}
                            <Box sx={sectionStyle}>
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    Medical History
                                </Typography>
                                <Grid container spacing={2}  >
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Have you taken any medications on the list?</span>
                                        <SelectInput source="any_medications" label="" choices={YesNo} validate={required()} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Have you had an ear or body piercing?</span>
                                        <SelectInput source="piercing" label="" choices={YesNo} validate={required()} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Have you had surgery or a medical procedure?</span>
                                        <SelectInput source="surgery" label="" choices={YesNo} validate={required()} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Have you had acupuncture?</span>
                                        <SelectInput source="acupuncture" label="" choices={YesNo} validate={required()} fullWidth />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Have you been pregnant or are you pregnant now?</span>
                                        <SelectInput source="pregnant" label="" choices={YesNoExt} validate={required()} fullWidth />
                                    </Grid>
                                </Grid>
                            </Box>

                            {/* Section 4: Additional Health Risks */}
                            <Box sx={sectionStyle}>
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    Additional Health Risks
                                </Typography>
                                <Snackbar
                                    open={openSnackbar}
                                    autoHideDuration={5000}
                                    onClose={() => setOpenSnackbar(false)}
                                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                >
                                    <Alert severity={notifyMessage?.type} sx={{
                                        fontSize: 24, 
                                        p: 2, 
                                        width: '100%', 
                                        textAlign: 'center', 
                                        bgcolor: notifyMessage?.type === "success" ? "#4caf50" : "#d32f2f", 
                                        color: "white",
                                        borderRadius: 2
                                    }}>
                                        {notifyMessage?.text}
                                    </Alert>
                                </Snackbar>
                                <Grid container spacing={2} >
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Have you had any new medical problems or diagnoses?</span>
                                        <SelectInput source="new_problem" label="" choices={YesNo} validate={required()} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Have you had new medical treatments, vaccinations, or medications?</span>
                                        <SelectInput source="new_medication" label="" choices={YesNo} validate={required()} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Have you had contact with someone who had a smallpox vaccination?</span>
                                        <SelectInput source="smallpox" label="" choices={YesNo} validate={required()} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Have you had Ebola Virus infection or disease?</span>
                                        <SelectInput source="ebola" label="" choices={YesNo} validate={required()} fullWidth />
                                    </Grid>
                                </Grid>
                            </Box>

                            {/* Section 5: Risk Poster */}
                            <Box sx={sectionStyle}>
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    Risk Awareness
                                </Typography>
                                <Grid container spacing={2} >
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Did you review the Risk Poster?</span>
                                        <SelectInput source="risk_poster" label="" choices={YesNo} validate={required()} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Do you have any questions about the Risk Poster?</span>
                                        <SelectInput source="risk_poster_question" label="" choices={YesNo} validate={required()} fullWidth />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Does anything on the Risk Poster apply to you?</span>
                                        <SelectInput source="risk_poster_apply_you" label="" choices={YesNo} validate={required()} fullWidth />
                                    </Grid>
                                </Grid>
                            </Box>

                            <TextInput
                                id="branch_code"
                                source="branch_code"
                                defaultValue={(localStorage?.token ? jwt_decode(localStorage.token)?.branch_code : '')}
                                style={{ display: 'none' }}
                            />
                            <TextInput
                                    source="ssn"
                                    defaultValue={(props?.location?.search?.split('=')[1]) || ''}
                                    style={{ display: 'none' }}
                            />
                        </Paper>
                    </Container>  
                </FormTab>
    
                
            </TabbedForm>
        </Create>
    );
}

export default withStyles(editStyles)(QuestionCreate);
